/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else {
          // PM: a sign-up through any form on the page hides the pop-up for a year.
          const subscribed = document.querySelector('.signup-form__response--success');
          this.dismissDays = subscribed ? 365 : parseInt(this.dataset.dismissDays, 10);
          if (subscribed) setCookie(this.cookie, true, this.dismissDays);

          // PM: count pages viewed this visit; the delay trigger waits for the second.
          let pageViews = 1;
          try {
            pageViews = Number(sessionStorage.getItem('pm-popup-pages') || 0) + 1;
            sessionStorage.setItem('pm-popup-pages', pageViews);
          } catch (err) { /* storage blocked: treat as a first page */ }

          if (this.querySelector('.alert')) {
            this.open();
          } else if (!subscribed && !getCookie(this.cookie)
            && (this.dataset.showOnMobile === 'true' || theme.mediaMatches.md)) {
            if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
              this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
              document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
            } else if (pageViews >= 2) {
              // PM: delay trigger, and the touch-screen fallback for exit intent.
              setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
            }
          }
        }
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        setCookie(this.cookie, true, this.dismissDays || parseInt(this.dataset.dismissDays, 10));
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
